export const Account = (api) => ({
  avatar: {
    store(attachmentObject) {
      return api.patch('/v1/account/avatar', attachmentObject)
    },
    delete() {
      return api.delete('/v1/account/avatar')
    }
  },
  locale: {
    store(locale) {
      return api.patch('/v1/account/locale', { locale })
    }
  },
  security: {
    get() {
      return api.get('/v1/account/security')
    },
    tryChangePhone(phone) {
      return api.patch('/v1/account/security/phone', { phone })
    },
    tryChangeEmail(email) {
      return api.patch('/v1/account/security/email', { email })
    },
    verifyCode(type, verifierSlug, code, password) {
      return api.patch(`/v1/account/security/${type}/${verifierSlug}`, {
        code,
        password
      })
    },
    twoFactor: {
      sendCode() {
        return api.patch('/v1/account/security/2fa')
      },
      toggle(verifierSlug, code) {
        return api.patch(`/v1/account/security/2fa/${verifierSlug}`, { code })
      }
    },
    changePassword(form) {
      return api.patch('/v1/account/security/password', form)
    },
    storageConfirmation: {
      confirm() {
        return api.put('/v1/account/security/storage-confirmation')
      }
    },
    requestAccountDeletion() {
      return api.post('/v1/account/security/deletion-request')
    }
  },
  password: {
    forgot(email) {
      return api.post('/v1/account/forgot-password', { email })
    },
    reset(form) {
      return api.post('/v1/account/reset-password', form)
    }
  },
  candidate: {
    registration(form) {
      return api.post('/v1/public/candidate/registration', form)
    }
  }
})
